import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { IdentitableButtonEnum } from 'src/app/shared/components/subscription-pages/subscription-tables/desktop/subscription-table-desktop.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upgrade-account',
  templateUrl: './upgrade-account.component.html'
})
export class UpgradeAccountComponent implements OnInit, OnDestroy {

  public desktopViewVisible: boolean;

  private _subs: Subscription[] = [];

  constructor(
    private _breakpointObserver: BreakpointObserver,
    private _router: Router
  ) { }

  ngOnInit() {
    this.handleHeaderElementVisibility();
  }

  ngOnDestroy() {
    this._subs.forEach(it => it.unsubscribe());
  }

  public onIdentitableButtonClicked(buttonClickedName: string) {
    switch (buttonClickedName) {
      case IdentitableButtonEnum.IdentibasePlusButton:
        this.navigateToIdentibasePlusPage();
        break;
      case IdentitableButtonEnum.IdentialertButton:
        this.navigateToIdentialertPage();
        break;
      case IdentitableButtonEnum.IdentifindButton:
        this.navigateToIdentifindPage();
        break;
    }
  }

  private navigateToIdentibasePlusPage() {
    this._router.navigate(['/identibase-plus']);
  }

  private navigateToIdentialertPage() {
    this._router.navigate(['/identialert']);
  }

  private navigateToIdentifindPage() {
    this._router.navigate(['/identifind']);
  }


  private handleHeaderElementVisibility() {
    this._subs.push(
      this._breakpointObserver
      .observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.desktopViewVisible = state.matches;
      })
    );
  }

}
